import React from "react";
import styled from "styled-components";
import withProviders from "../../hooks/withProviders";
import ClientDocumentsTable from "../../features/clientdocumentstable";
import { toNString } from "../../helpers/guids";
import { IconButton } from "../../components";
import { FormInputWithSearchIcon } from "../../components/forms";
import { useAuth } from "react-oidc-context";
import { useClientContext } from "../../hooks/ClientContext";
import { openDocumentFiltersModal } from "../../components/modals/document-filter";
import { openDocumentUploadModal } from "../../components/modals/document-upload";
import { ClientLayoutPageSubHeader, Main, ThemedIcon, ThemedParagraph } from "../../components/utilities";
import { ClientDocumentsFilteredProvider, useClientDocuments } from "../../hooks/ClientDocumentsContext";
import { FilterProvider, useFilterContext, ClientDocumentDefaultFilters } from "../../hooks/FilterContext";

const ClientdocumentFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

const ClientDocumentsPage = () => {
    const { user: { profile } } = useAuth();
    const { account } = useClientContext();
    const { clear, searchTerm, setSearchTerm } = useClientDocuments();
    const { filter, clearFilter, isFiltersApplied, setFilter } = useFilterContext();
    const [formSearchTerm, setFormSearchTerm] = React.useState(searchTerm);

    const onFilterButtonClicked = () => {
        openDocumentFiltersModal(filter, searchTerm, account.masterAccountId).then(
            form => {
                const { searchTerm, ...rest } = form;
                setFilter(() => ({ ...rest }));
            }
        );
    };

    const onUploadButtonClicked = () => {
        openDocumentUploadModal({ 
            adviserId: account.adviserId,
            divisionId: account.divisionId,
            masterAccountId: account.masterAccountId,
            projectId: null,
            userId: toNString(profile.sub)
        }).then(
            () => clear()
        )
    };

    React.useEffect(() => {
        const updateFilters = setTimeout(() => {
            setSearchTerm(_ => formSearchTerm);
        }, 500);
        return () => clearTimeout(updateFilters);
    }, [formSearchTerm])

    return (
        <React.Fragment>
            <ClientLayoutPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <ClientdocumentFiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </ClientdocumentFiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center">
                        <FormInputWithSearchIcon
                            className="w-25 mx-1"
                            placeholder="Search for a Document."
                            value={formSearchTerm}
                            disableAnimations={true}
                            onChange={(e) => setFormSearchTerm(e.target.value)}
                        />
                        <div className="d-flex gap-1">
                            <IconButton icon="fas fa-filter" onClick={onFilterButtonClicked}>Filter Documents</IconButton>
                            <IconButton icon="fas fa-cloud-upload-alt" variant="success" onClick={onUploadButtonClicked}>Upload Document</IconButton>
                        </div>
                    </div>
                </div>
            </ClientLayoutPageSubHeader>
            <Main className="p-3">
                <ClientDocumentsTable />
            </Main>
        </React.Fragment>
    );
};

export default withProviders(
    [FilterProvider, { filterStore: 'clientDocuments', defaultFilters: ClientDocumentDefaultFilters }],
    [ClientDocumentsFilteredProvider]
)(ClientDocumentsPage);